<template>
	<div class="small-12 addForm createNewInvoiceMenu animated fadeInRight border-top border-right" v-if="open_invoice_menu && rent" v-bind:class="{ active: open_invoice_menu }">
        <div class="small-12 columns panelMenuWrapper">
			<div class="small-12 formTitle border-bottom">
				<h2 class="small-12 flex vertical-align justify-between">
					<span class="float-left small-8">
						Create Invoice
					</span>
					<i class="material-icons-outlined transition" @click="closeNewInvoiceMenu()">cancel</i>
				</h2>
			</div>
			<div class="small-12 formBody">
				<div class="small-12 image borderRadius8">
					<picture class="flex small-12 justify-center">
						<img class="invoiceImage" width="200" :src="vector_image" alt="A lease crawling out of the browser.">
					</picture>
				</div>
				<div class="small-12 sectionTitle flex first">
					<h2>Rent Amount</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Amount (USD)<em class="cRed">*</em></label>
					<div class="small-12 addOnContainer borderRadius8">
						<input class="inputAddition disabled" type="number" step="0.01" name="invoice_amount" placeholder="0.00" v-model="new_rent_invoice.attributes.charge.amount" disabled/>
						<div class="add-on borderRadius8">
							<i class="material-icons-outlined">attach_money</i>
						</div>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex" v-if="payment_method_set && rent.attributes.transaction_fees_policy.resident.fee_amount > 0">
					<h2>Transaction Fee</h2>
				</div>
				<fieldset class="small-12 flex inputGroup" v-if="payment_method_set && rent.attributes.transaction_fees_policy.resident.fee_amount > 0">
					<label class="small-12">Amount (USD)<em class="cRed">*</em></label>
					<div class="small-12 addOnContainer borderRadius8">
						<input class="inputAddition disabled" type="number" step="0.01" name="invoice_amount" placeholder="0.00" v-model="transactionFee" disabled/>
						<div class="add-on borderRadius8">
							<i class="material-icons-outlined">attach_money</i>
						</div>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex">
					<h2>Invoice Dates</h2>
				</div>
				<div class="small-12 flex vertical-align">
					<div class="small-12 large-6 columns" style="padding-left:0;">
						<label class="small-12">Due On<em class="cRed">*</em></label>
						<div class="small-12" @click="setCalendarPickerIndex($event)">
							<datetime v-model="new_rent_invoice.attributes.due_on.date" value-zone="local" zone="local" :phrases="{ok: 'Select', cancel: 'Cancel'}" :format="{ month: 'numeric', day: 'numeric', year: 'numeric' }" @input="proratedRent"></datetime>	
						</div>
					</div>
					<div class="small-12 large-6 columns" style="padding-left:0;">
						<label class="small-12">Notify By</label>
						<input class="disabled" type="date" name="invoice_notify_by_date" v-model="new_rent_invoice.attributes.notification.date" disabled>
					</div>
				</div>
				<div class="small-12 sectionTitle flex">
					<h2>Late By</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Late Fee (USD)</label>
					<div class="small-12 addOnContainer borderRadius8">
						<input class="inputAddition disabled" type="number" step="0.01" name="late_fee" placeholder="0.00" v-model="new_rent_invoice.attributes.charge.policy_late_fee" disabled/>
						<div class="add-on borderRadius8">
							<i class="material-icons-outlined">attach_money</i>
						</div>
					</div>
					<div class="small-12" style="margin-top:1rem;">
						<label class="small-12">Late By</label>
						<input class="disabled" type="date" name="invoice_late_by_date" v-model="new_rent_invoice.attributes.late_policy.date" disabled>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex">
					<h2>Proration</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<div class="small-12 flex" style="margin-bottom:16px;">
						<div class="small-12 large-3 toggle-button">
							<toggle-button v-model="new_rent_invoice.attributes.proration.prorated" color="#18bbf7" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" :width="90" :height="40" :font-size="14"/>
						</div>
						<div class="labelDefinitions small-12 large-9 columns flex vertical-align">
							<p class="small-12 columns"><b>Prorate Rent Amount</b></p>
							<span class="small-12 columns">Would you like to prorate the rent amount?</span>
						</div>
					</div>
					<div class="small-12 prorated animated fadeIn" v-if="new_rent_invoice.attributes.proration.prorated">
						<label class="small-12">Prorated Rent Amount<em class="cRed">*</em> ({{proratedDays}} Days)</label>
						<div class="small-12 addOnContainer borderRadius8">
							<input class="readOnly inputAddition" type="number" step="0.01" name="prorated_rent_amount" disabled v-model="new_rent_invoice.attributes.proration.amount">
							<div class="add-on borderRadius8">
								<i class="material-icons-outlined">attach_money</i>
							</div>
						</div>
					</div>
				</fieldset>
				<div class="small-12 sectionTitle flex">
					<h2>Statement Description</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<label class="small-12">Description<em class="cRed">*</em></label>
					<textarea name="description" id="description" class="borderRadius8 description" v-model="new_rent_invoice.attributes.description"></textarea>
				</fieldset>
				<div class="small-12 sectionTitle flex">
					<h2>Invoice Summary</h2>
				</div>
				<fieldset class="small-12 flex inputGroup">
					<ol class="small-12 float-left flex bullets">
						<li class="small-12" style="margin-bottom:15px;">
							<p class="small-12">
								<b class="cPrimary" v-if="!new_rent_invoice.attributes.proration.prorated">${{ invoiceTotal | convertCentsToDollars }}</b> 
								<b class="cPrimary" v-else>${{ proratedInvoiceTotal | convertCentsToDollars }}</b>
								will be invoiced on 
								<b class="cPrimary">{{new_rent_invoice.attributes.due_on.date | dueDate}}</b>.
							</p>
						</li>
						<li class="small-12" v-if="payment_method_set && rent.attributes.transaction_fees_policy.resident.fee_amount > 0">
							<p class="small-12">
								A <b class="cPrimary">${{ rent.attributes.transaction_fees_policy.resident.fee_amount | convertCentsToDollars }}</b> electronic payments transaction fee will be added to the invoice.
							</p>
						</li>
						<li class="small-12">
							<p class="small-12">
								<b class="cPrimary">1</b> invoice will be added to the rent term.
							</p>
						</li>
						<li class="small-12" v-if="resident && !resident.attributes.site_enrollment.enroll_resident">
							<p class="small-12">
								<b class="cPrimary">Please note:</b> The resident is not enrolled in the residents site to use electronic payments. Due to this, the resident will not be charged and this rent term is for documentation purposes only.
							</p>
						</li>
						<li class="small-12" v-else-if="resident && resident.attributes.site_enrollment.enroll_resident && !resident.attributes.site_enrollment.enrollment_date">
							<p class="small-12">
								<b class="cPrimary">Please note:</b> The resident has been enrolled in the residents site to use electronic payments. Unfortunately, the resident hasn't completed registration. The invoice will still be created for the resident.
							</p>
						</li>
						<li class="small-12" v-if="new_rent_invoice.attributes.proration.prorated">
							<p class="small-12">
								This invoice is prorated and will be invoiced for <b class="cPrimary">{{proratedDays}}</b> days totaling <b class="cPrimary">${{proratedInvoiceTotal | convertCentsToDollars}}</b>.
							</p>
						</li>
					</ol>
				</fieldset>
			</div>
		</div>
		<div class="small-12 columns panelActions flex justify-center vertical-align border-top">
			<a class="blueButton small-12 flex justify-center borderRadius8 vertical-align" @click="createTheRentInvoice()">
				Create Rent Invoice
			</a>
		</div>
    </div>
</template>

<script>

	// Import firebase
	import { propertiesModel } from '@/firebase/firebase-config'

	// Import the mixins
    import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'
	import { MoneyConversions } from '@/mixins/filters/MoneyConversions'

	// Import the events
	import { CreateInvoice } from '@/events/invoices/CreateInvoice'

	// Import the components
	import { Datetime } from 'vue-datetime'
    
	export default {

		/*
		** Set the component name
		*/

		name: 'CreateInvoiceMenu',

		/*
		**  Register the components
		*/

		components: {

			datetime: Datetime

		},

		/*
		**  Register the mixins
		*/

		mixins: [

            BugsnagService,
            SpinnerMethods,
			MoneyConversions,
			CreateInvoice

		],

		/*
		**  Set the props
		*/

		props: {

			menu_action: {
				type: Boolean,
				default: false
            },
            rent: {
                type: Object,
                default: () => null
            },
            property: {
				type: Object,
				default: () => null
			},
			lease: {
				type: Object,
				default: () => null
			},
			resident: {
				type: Object,
				default: () => null
			},
			unit: {
				type: Object,
				default: () => null
			},
			user: {
				type: Object,
				default: () => null
			},
			company: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

            open_invoice_menu: false,
            vector_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Finvoice.svg?alt=media&token=a69ba27c-485d-4800-9176-9bd70e2f1d07',
            proratedDays: 0,
            due_date_is_before_today: false,
            due_date_is_between_rent_term_dates: false,
            due_date_exists: false,
            total_charges_check: false,
			existing_invoices: null,
			processing: false,
			proration_applied: false,
			valid_due_date: false,
			payment_method_set: false

		}),

		/*
		**  Watch em'
		*/

		watch: {

			menu_action: {

				immediate: true, // Load on created
				handler(menu_action) {

					/*
                    **  Set the prop
                    **  @location: @here
                    */

					try {

						if (menu_action) this.open_invoice_menu = true;

					} catch (e) {

						/*
						**  Send to Bugsnag
						**  @service: Bugsnag/BugsnagService
						*/

						this.reportAuthBugsnagError({
							title: 'Open the create an invoice menu from the menu action.',
							errorType: 'Application',
							section: 'Invoice',
							uid: '1BwlSFxy2t6PlIGEB5ge',
							error: e
						});

					}

				}

            },

            rent: {

				immediate: true, // Load on created
				handler(rent) {

					/*
					**  Set the props
					**  @method: @here
					*/

					if (rent) this.setPropsFromRent();

				}

			},
			
			company: {

				immediate: true, // Load on created
				handler(company) {

					/*
					**  Check if payment methods have been set
					**  @method: @here
					*/

					if (company) this.checkPaymentMethods();

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			checkPaymentMethods: function() {

				try {

					if (this.company.attributes.settings.payment_methods.cards || this.company.attributes.settings.payment_methods.ach) this.payment_method_set = true;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Check if payment methods have been set for the Create Invoice Menu.',
						errorType: 'Application',
						section: 'Invoice',
						uid: 'V1fFAS1ZivWMTP9yIZwV',
						error: e
					});

				}

			},

            setPropsFromRent: function() {

				try {

					/*
					**  Bind the existing invoices
					**  @service: @VueFire
					*/

					this.$bind('existing_invoices', propertiesModel.doc(this.$route.params.id).collection('leases').doc(this.lease.id).collection('rents').doc(this.rent.id).collection('invoices'));

					/*
					**  Set the variables
					*/

					let lateFee = this.rent.attributes.policy.late_fee / 100,
						amount = this.rent.attributes.amount / 100;
					 
					/*
					**  Set the late fee
					**  @prop: @here
					*/

					this.new_rent_invoice.attributes.charge.policy_late_fee = lateFee;

					/*
					**  Set the amount
					**  @prop: @here
					*/

					this.new_rent_invoice.attributes.charge.amount = amount;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Set the props from the rent.',
						errorType: 'Application',
						section: 'Invoice',
						uid: '9wvgOpioCeCFZCg7Psbb',
						error: e
					});

				}

            },

			closeNewInvoiceMenu: function() {

				try {
 
					/*
					**  Close the menu
					**  @prop: @here
					*/

					this.open_invoice_menu = false;
 
					/*
					**  Emit the event
					**  @service: @Vue
					*/

					this.$emit('closeCreateInvoiceMenu', true);
 
					/*
					**  Reset the prop
					**  @method: @here
					*/

					this.resetNewRentInvoiceProp();
 
					/*
					**  Set the props again
					**  @method: @here
					*/

					this.setPropsFromRent();

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Close the new invoice menu.',
						errorType: 'Application',
						section: 'Invoice',
						uid: 'fbRf7NE4mXGvKVVMQVQo',
						error: e
					});

				}

			},

            createTheRentInvoice: function() {

				/*
				**  Validate
				**  @method: @here
				*/

				let validated = this.validate();

				if (!validated) {

					/*
					**  Show error message
					**  @service: SweetAlert2
					*/

					this.$swal('Uh Oh!', 'Please fill out all required fields before creating a new rent invoice.', 'error');

					return;

				}
				
				/*
				**  Valid due date check
				**  @method: @here
				*/

				this.validDueDateCheck();

				if (!this.valid_due_date) {

					/*
					**  Show error message
					**  @service: SweetAlert2
					*/

					this.$swal('Uh Oh!', 'Please enter in a valid due date.', 'error');
                    
					/*
					**  Reset the checks and balances
					**  @method: @here
					*/

                    this.resetChecksProps();

					return;

				}
 
				/*
				**  Due date checks
				**  @method: @here
				*/

				this.dueDateChecks();

				/*
				**  Due date exists check
				**  @method: @here
				*/

				if (this.due_date_exists) {

					/*
					**  Show error message
					**  @service: SweetAlert2
					*/

					this.$swal('Uh Oh!', 'Please enter a due date that does not already exist on another invoice.', 'error');
                    
                    /*
					**  Reset the checks and balances
					**  @method: @here
					*/

                    this.resetChecksProps();

					return;

				}

				/*
				**  Due date checks
				**  @method: @here
				*/

				if (!this.due_date_is_between_rent_term_dates) {

					/*
					**  Show error message
					**  @service: SweetAlert2
					*/

					this.$swal('Uh Oh!', 'Please enter a due date that falls within the rent term\'s starting and ending dates.', 'error');
                    
                    /*
					**  Reset the checks and balances
					**  @method: @here
					*/

                    this.resetChecksProps();

					return;

				}
 
				/*
				**  Check if total charges on rent term are up
				**  @method: @here
				*/

				this.rentTotalChargesCheck();

				if (this.total_charges_check) {

					/*
					**  Show error message
					**  @service: SweetAlert2
					*/

					this.$swal('Uh Oh!', 'Looks like all rent invoices have been created for this rent term. Please create a new rent term to proceed.', 'error');

                    /*
					**  Reset the checks and balances
					**  @method: @here
					*/

                    this.resetChecksProps();

					return;

				}
 
				/*
				**  Check if proration needs to be applied
				**  @method: @here
				*/

				this.prorationCheck();

				if (this.rent.attributes.first_month.prorated && !this.proration_applied) {

					/*
					**  Show error message
					**  @service: SweetAlert2
					*/

					this.$swal('Uh Oh!', 'The rent term\'s proration policy states that the first rent invoice must be prorated. Please prorate this invoice before proceeding.', 'error');

                    /*
					**  Reset the checks and balances
					**  @method: @here
					*/

                    this.resetChecksProps();

					return;

				}

				/*
				**  Set the processing prop
				**  @prop: @here
				*/
				
				this.processing = true;

				/*
				**  Create the invoice
				**  @method: Events/Invoices/CreateInvoice
				*/

				this.createInvoiceHandler();

            },

            validate: function() {

				try {
 
					/*
					**  Required fields
					*/

					if (this.new_rent_invoice.attributes.charge.amount == 0 || this.new_rent_invoice.attributes.charge.amount.length == 0) return false;
					if (this.new_rent_invoice.attributes.due_on.date == null || this.new_rent_invoice.attributes.due_on.date.length == 0) return false;
					if (this.new_rent_invoice.attributes.description == null || this.new_rent_invoice.attributes.description.length == 0) return false;

					return true;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Validate the required fields in Create Invoice Menu.',
						errorType: 'Application',
						section: 'Invoice',
						uid: 'ni0V6AfnUXRwsQoPJqcr',
						error: e
					});

				}

			},
			
			validDueDateCheck: function() {

				try {

					/*
					**  Set the vars
					*/

					let dueDate = moment(this.new_rent_invoice.attributes.due_on.date);
 
					/*
					**  Check if valid
					*/

					if (dueDate.isValid()) this.valid_due_date = true;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Validate the Due Date Format in Create Invoice Menu.',
						errorType: 'Application',
						section: 'Invoice',
						uid: 'uYcPuBmYsR5vzOHp2UFn',
						error: e
					});

				}

			},
            
            dueDateChecks: function() {

				try {

					/*
					**  Set to moment instance
					*/

					let dueAt = moment(this.new_rent_invoice.attributes.due_on.date);
 
					/*
					**  Determine is before today
					**  @prop: @here
					*/

					this.due_date_is_before_today = moment(this.new_rent_invoice.attributes.due_on.date).isBefore(moment());
					 
					/*
					**  Check if due date falls between rent term dates
					**  @prop: @here
					*/

					this.due_date_is_between_rent_term_dates = moment(this.new_rent_invoice.attributes.due_on.date).isBetween(moment(this.rent.attributes.term_dates.starting_at * 1000).format('YYYY-MM-DD'), moment(this.rent.attributes.term_dates.ending_at * 1000).format('YYYY-MM-DD'));

					/*
					**  If false, check if the date falls on the two rent term dates
					**  @prop: @here
					*/

					if (!this.due_date_is_between_rent_term_dates) {

						let endDayMatch = false,
							startDayMatch = false;

						startDayMatch = moment(this.new_rent_invoice.attributes.due_on.date).isSame(moment(this.rent.attributes.term_dates.starting_at * 1000).format('YYYY-MM-DD'));
						endDayMatch = moment(this.new_rent_invoice.attributes.due_on.date).isSame(moment(this.rent.attributes.term_dates.ending_at * 1000).format('YYYY-MM-DD'));

						// If the same, allow date to be accepted
						if (startDayMatch || endDayMatch) {

							this.due_date_is_between_rent_term_dates = true;

						}

					}
 
					/*
					**  Check if the due date has already been used
					**  @prop: @here
					*/

					if (this.existing_invoices.length > 0) {

						this.existing_invoices.forEach(invoice => {

							if (invoice.attributes.due_on.date == dueAt.unix()) this.due_date_exists = true;

						});

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Due Date Checks Failed in Create Invoice Menu.',
						errorType: 'Application',
						section: 'Invoice',
						uid: 'XBHk7lIZgT4RcB1vEr13',
						error: e
					});

				}

            },

            rentTotalChargesCheck: function() {

				try {

					if (this.existing_invoices.length !== 0 && this.existing_invoices.length >= this.rent.metrics.total_charges) {

						this.total_charges_check = true;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Rent Total Charges Check Failed in Create Invoice Menu.',
						errorType: 'Application',
						section: 'Invoice',
						uid: 'jSIS1zyT7GT13rWImy98',
						error: e
					});

				}

			},
			
			prorationCheck: function() {

				try {
 
					/*
					**  Search listing for a current prorated invoice
					*/

					let prorated_invoice = this.existing_invoices.filter(invoice => {

						return invoice.attributes.proration.prorated == true;

					});

					/*
					**  If one exists, set to true
					*/

					if (prorated_invoice.length > 0 || this.new_rent_invoice.attributes.proration.prorated) this.proration_applied = true;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Proration Check Failed in Create Invoice Menu.',
						errorType: 'Application',
						section: 'Invoice',
						uid: '1076td7tQBesZCmWv6Bk',
						error: e
					});

				}

			},

            resetChecksProps: function() {

				try {

					/*
					**  Reset the props
					*/

					this.proratedDays = 0;
					this.due_date_is_before_today = false;
					this.due_date_is_between_rent_term_dates = false;
					this.due_date_exists = false;
					this.total_charges_check = false;
					this.proration_applied = false;
					this.valid_due_date = false;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Reset the Validation Props in Create Invoice Menu.',
						errorType: 'Application',
						section: 'Invoice',
						uid: 'Q7M1y0aN4q6UrZuTQrfM',
						error: e
					});

				}

            },

			setCalendarPickerIndex: function(event) {

                try {

                    /*
					**  Emit the event
					**  @service: @Vue
					*/

                    this.$emit('setCalendarPickerIndex', true);
                    
                } catch (e) {

                    /*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Emit the set calendar picker index event.',
						errorType: 'Application',
						section: 'Create Invoice Menu',
						uid: 'MpbY0J8doZUaVNmoy0b9',
						error: e
					});

                }

            }

		},

		/*
		**  Set the computed props
		*/

		computed: {

			proratedRent: function() {

				try {

					if (!this.processing && this.new_rent_invoice.attributes.charge.amount > 0 && this.new_rent_invoice.attributes.due_on.date) {

						// Set the vars
						let startDate = moment(this.new_rent_invoice.attributes.due_on.date).format('DD'),
							totalDaysInMonth = moment(this.new_rent_invoice.attributes.due_on.date).daysInMonth(),
							daysRemaining = totalDaysInMonth - startDate; 

						// Calculate days since lease beginning date
						let amount = ((this.new_rent_invoice.attributes.charge.amount / totalDaysInMonth) * daysRemaining).toFixed(2);

						// Set the dates from rent
						let lateByDifference = 0,
							daysInAdvance = 0;

						// Calculate the difference
						if (this.rent.attributes.policy.late_by) lateByDifference = this.rent.attributes.policy.late_by - this.rent.attributes.policy.due_on;
						if (this.rent.attributes.due_notification.days_in_advance) daysInAdvance = this.rent.attributes.policy.due_on + this.rent.attributes.due_notification.days_in_advance;

						// Set the props
						let lateByDate = moment(this.new_rent_invoice.attributes.due_on.date).add(lateByDifference, 'days').format('YYYY-MM-DD'),
							notificationDate = moment(this.new_rent_invoice.attributes.due_on.date).subtract(daysInAdvance, 'days').format('YYYY-MM-DD');
						
						this.new_rent_invoice.attributes.late_policy.date = lateByDate;
						this.new_rent_invoice.attributes.notification.date = notificationDate;

						// Add to props
						this.new_rent_invoice.attributes.proration.amount = amount;
						this.proratedDays = daysRemaining;
						this.new_rent_invoice.attributes.description = moment(this.new_rent_invoice.attributes.due_on.date).format('MMMM') + ' ' + moment(this.new_rent_invoice.attributes.due_on.date).format('YYYY') + ' rent invoice for ' + this.unit.attributes.address.street_1 + ', Unit: ' + this.unit.attributes.number + '.';

					} else if (!this.processing && this.new_rent_invoice.attributes.due_on.date) {

						// Add to prop
						this.new_rent_invoice.attributes.proration.amount = 0;
						this.proratedDays = 0;
						
						// Set the dates from rent
						let lateByDifference = 0,
							daysInAdvance = 0;

						// Calculate the difference
						if (this.rent.attributes.policy.late_by) lateByDifference = this.rent.attributes.policy.late_by - this.rent.attributes.policy.due_on;
						if (this.rent.attributes.due_notification.days_in_advance) daysInAdvance = this.rent.attributes.policy.due_on + this.rent.attributes.due_notification.days_in_advance;

						// Set the props
						let lateByDate = moment(this.new_rent_invoice.attributes.due_on.date).add(lateByDifference, 'days').format('YYYY-MM-DD'),
							notificationDate = moment(this.new_rent_invoice.attributes.due_on.date).subtract(daysInAdvance, 'days').format('YYYY-MM-DD');
						
						this.new_rent_invoice.attributes.late_policy.date = lateByDate;
						this.new_rent_invoice.attributes.notification.date = notificationDate;

					} else if (!this.processing) {

						// Add to prop
						this.new_rent_invoice.attributes.proration.amount = 0;
						this.proratedDays = 0;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Calculate Prorated Rent Failed in Create Invoice Menu.',
						errorType: 'Application',
						section: 'Invoice',
						uid: 'jgWPz0NypSGLWiL5jBVu',
						error: e
					});

				}

			},

			invoiceTotal: function() {

				try {

					// Set the vars
					let transactionFee = 0,
						rent = 0;

					// Set the transaction fee amount
					if (this.rent && this.rent.attributes.transaction_fees_policy.resident.fee_amount > 0) transactionFee = this.rent.attributes.transaction_fees_policy.resident.fee_amount;

					// Set the total rent amount
					if (this.rent && this.rent.attributes.amount > 0) rent = this.rent.attributes.amount;

					return rent + transactionFee;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Calculate Invoice Total Failed in Create Invoice Menu.',
						errorType: 'Application',
						section: 'Invoice',
						uid: 'jFxBv3Zod2hw3ir0RmCu',
						error: e
					});

				}

			},

			proratedInvoiceTotal: function() {

				try {

					// Set the vars
					let transactionFee = 0,
						rent = 0;

					// Set the transaction fee amount
					if (this.rent && this.rent.attributes.transaction_fees_policy.resident.fee_amount > 0) transactionFee = this.rent.attributes.transaction_fees_policy.resident.fee_amount;

					// Set the total rent amount
					if (this.rent && this.rent.attributes.first_month.charge_amount > 0) rent = this.rent.attributes.first_month.charge_amount;

					return rent + transactionFee;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Calculate Prorated Invoice Total Failed in Create Invoice Menu.',
						errorType: 'Application',
						section: 'Invoice',
						uid: 'rmaGPiZIjqbh0yJps8g5',
						error: e
					});

				}

			},

			transactionFee: function() {

				try {

					if (this.rent && this.rent.attributes.transaction_fees_policy.resident.fee_amount > 0) return this.rent.attributes.transaction_fees_policy.resident.fee_amount / 100;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/

					this.reportAuthBugsnagError({
						title: 'Calculate Transaction Fee Failed in Create Invoice Menu.',
						errorType: 'Application',
						section: 'Invoice',
						uid: 'Wh7SCeSMtrrfyE3NYVis',
						error: e
					});

				}
				
			}

		},

		/*
		**  Set the filters
		*/

		filters: {

			dueDate: function(value) {

                if (value) return moment(value).format('MM/DD/YYYY');
                
            }

		}

	}

</script>